export const GET_INVITE = 'GET_INVITE';
export const SET_INVITE = 'SET_INVITE';
export const SEND_INVITE = 'SEND_INVITE';
export const CLEAR_INVITE = 'CLEAR_INVITE';
